import {
  Component, Input, Output, EventEmitter, OnChanges
  , ViewChild, ElementRef, SimpleChange, Renderer2,
  AfterViewInit, ViewChildren, QueryList, OnDestroy
} from '@angular/core';

import { Grid } from '../../lib/grid';
import { Row } from '../../lib/data-set/row';
import { DataSource } from '../../lib/data-source/data-source';
import { Column } from '../../lib/data-set/column';
import { OnInit } from '@angular/core';
import { SmartTableService } from '../../../../smart-table-service';
import { CellComponent } from '../cell/cell.component';
import { Subscription } from 'rxjs';

@Component({
    selector: '[ng2-st-tbody]',
    templateUrl: './tbody.component.html',
    styleUrls: ['./tbody.component.scss'],
    standalone: false
})
export class Ng2SmartTableTbodyComponent implements OnChanges,
AfterViewInit, OnDestroy {

  @Input() public grid: Grid;
  @Input() public source: DataSource;
  @Input() public deleteConfirm: EventEmitter<any>;
  @Input() public editConfirm: EventEmitter<any>;
  @Input() public rowClassFunction: Function;
  @Input() public focus: EventEmitter<any>;

  @Output() public save = new EventEmitter<any>();
  @Output() public cancel = new EventEmitter<any>();
  @Output() public edit = new EventEmitter<any>();
  @Output() public delete = new EventEmitter<any>();
  @Output() public custom = new EventEmitter<any>();
  @Output() public edited = new EventEmitter<any>();
  @Output() public userSelectRow = new EventEmitter<any>();
  @Output() public editRowSelect = new EventEmitter<any>();
  @Output() public multipleSelectRow = new EventEmitter<any>();
  @Output() public rowHover = new EventEmitter<any>();
  @Output() public cancelUpdate = new EventEmitter<any>();
  @Output() public revoke = new EventEmitter<any>();
  @Output() public undo = new EventEmitter<any>();
  @Output() public reissue = new EventEmitter<any>();
  @Output() public blur = new EventEmitter<any>();
  @Output() public linkClickEvent = new EventEmitter<any>();
  public isMultiSelectVisible: boolean;
  public showActionColumnLeft: boolean;
  public showActionColumnRight: boolean;
  public mode: string;
  public editInputClass: string;
  public isActionAdd: boolean;
  public isActionEdit: boolean;
  public isActionDelete: boolean;
  public noDataMessage: boolean;
  public myFocus: boolean = false;
  public focusCellSubscription: Subscription;
  @ViewChildren('cellTemplate', {read: ElementRef}) public cells: QueryList<ElementRef>;
  constructor(private smartTableService: SmartTableService, private hostElement: ElementRef) {
  }
  public ngAfterViewInit() {
    this.focusCellSubscription = this.smartTableService.onFocusRow.subscribe((rowData) => {
      let rows = this.grid.getRows();
      let isEditable = false;
      for (const row of rows) {
        if (row.isDeleted || row.isInEditing || row.isReissued || row.isRevoked || row.isUndo) {
          isEditable = true;
        }
      }
      if (isEditable) {
        this.setFocusOnCell(rowData);
      }
    });
  }

  public setFocusOnCell(rowData) {
    let cells = this.cells.toArray();
    let columns = this.grid.getColumns();
    let columnsLength = columns.length;
    let columnIndex = columns.findIndex((record) => {
      return record.id === rowData.columnName;
    });
    // With row index and number of columns known we
    // can identify cell index using below formulae
    let cellIndex = (rowData.rowIndex * columnsLength) + columnIndex;
    // querying the element with input property which is a child of the
    // desired cell to focus.
    //
    // Note:-  Focus method only works on HTML input element and not on
    // angular components
    let element = cells[cellIndex].nativeElement.querySelector('input');
    element.focus();
  }

  public ngOnDestroy() {
    this.focusCellSubscription.unsubscribe();
  }

  public ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    this.isMultiSelectVisible = this.grid.isMultiSelectVisible();
    this.showActionColumnLeft = this.grid.showActionColumn('left');
    this.mode = this.grid.getSetting('mode');
    this.editInputClass = this.grid.getSetting('edit.inputClass');
    this.showActionColumnRight = this.grid.showActionColumn('right');
    this.isActionAdd = this.grid.getSetting('actions.add');
    this.isActionEdit = this.grid.getSetting('actions.edit');
    this.isActionDelete = this.grid.getSetting('actions.delete');
    this.noDataMessage = this.grid.getSetting('noDataMessage');
  }
  public onCheckBoxClickEvent(row: any) {
    row.isSelected = !row.isSelected;
    if (!row.isSelected) {
      row.highlighted = false;
      row.success = false;
    }
  }
}
